<script setup>
const props = defineProps({
      flagISOCode: {type: String, required: true},
      square: {type: Boolean, default: false}
});

import {useEnvStore} from '@dutypay/store-modules'
const envStore = useEnvStore();
import { computed } from 'vue';
const flagImageURL = computed(() => {
  return `${envStore.apiUrls.dutypay}/api/v0/assets/flag/${props.flagISOCode}/${props.square ? 'square' : 'standard'}/svg`
})
</script>

<script>
export default {
  name: "DpFlag"
}
</script>

<template>
  <img class="dp-flag speak-never" :class="{'square': props.square}" :src="flagImageURL" :alt="flagISOCode" />
</template>

<style lang="scss">
.dp-flag {
  margin-inline-end: 0.5em;
  vertical-align: text-bottom;
  display: inline-block;

  border-radius: 0.2em;
  border: .5px solid #ccc;
  border-top-color: #eee;
  border-bottom-color: #aaa;

  width: 1.33333333em;
  height: 1em;
  line-height: 1em;

  &.square {
    width: 1em;
  }
}
</style>
